module.exports = __webpack_public_path__ + "static/media/17GalleryPuppets.5c04ee7e.jpeg";